// Google Login

export default async function initGoogleLogin() {
  const $iframeContainer = $('.google_yolo_container');
  const isEmbeddedYolo = $iframeContainer.length !== 0;
  const $buttonContainer = $('.google_button_container');
  const isGoogleButton = $buttonContainer.length !== 0;

  if (!zr.page.model.GOOGLE_SIGNIN_CLIENT_ID
    || (!isGoogleButton && $.cookie(zr.page.model.google_signin_close_cookie))) {
    $buttonContainer.addClass('hide');
    return;
  }

  if (isEmbeddedYolo) {
    loadGoogleEmbeddedOneTap($iframeContainer);
  } else if (isGoogleButton) {
    $buttonContainer.removeClass('hide');
    await loadGoogleButton();
  } else if (!zr.page.model.isSerp) {
    // Lazy load imports for overlay-popup google yolo login ux
    await loadGoogleCornerPopup();
  }
}

async function loadGoogleCornerPopup() {
  await import('@static/js/zr/zr.GoogleYolo');
  await import('@static/js/zr/GoogleYolo/ZipLoginOrRegister');
  await import('@static/js/candidate/_google_signup_prompt');
}

function loadGoogleEmbeddedOneTap($iframeContainer) {
  // Embedded Google One Tap Implementation
  const configData = {
    clientId: zr.page.model.GOOGLE_SIGNIN_CLIENT_ID,
    disableAutoLogin: zr.page.model.google_signin_disable_auto_login || false,
  };

  function closeYoloFrame(message, showError, error) {
    $.log_event(message, error);

    if (showError) {
      $iframeContainer.text(message).addClass('error');
    } else {
      $iframeContainer.remove();
    }
    $(document).trigger('google_one_tap_closed');

    // if (!error) {
    //   const closeCookie = zr.page.model.google_signin_close_cookie;
    //   if (closeCookie) {
    //     // Set a cookie so we do not show this again for 7 days
    //     const date = new Date();
    //     date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
    //     document.cookie = `${closeCookie}=1; expires=${date.toUTCString()}; path=/`;
    //   }
    // }
  }

  const waitForModal = !!$('.modal-dialog #google_yolo_iframe').length;
  if (waitForModal) {
    const interval = setInterval(() => {
      if ($('.email_apply_modal.in').length === 1) {
        $('#google_yolo_iframe').attr('src', '/google-yolo-iframe.html');
        clearInterval(interval);
      }
    }, 200);
  } else {
    $('#google_yolo_iframe').attr('src', '/google-yolo-iframe.html');
  }

  window.addEventListener('message', (event) => {
    if (event.origin !== window.location.origin) {
      return;
    }
    const { data } = event.data;
    let { height } = event.data;
    let params;

    switch (event.data.type) {
      case 'yoloIframeReady':
        event.source.postMessage({
          type: 'sendClientId',
          data: configData,
        }, window.location.origin);
        break;
      case 'gotCredentials':
        params = {
          token: data.credential,
          reg_method: configData.regMethod,
          login_method: data.__auto ? configData.autoLoginMethod : configData.loginMethod, // eslint-disable-line no-underscore-dangle
        };

        registerWithZip(params, configData, closeYoloFrame);
        break;
      case 'height':
        // Update the parent <iframe> height to match GoogleYolo <iframe> height
        if (!zr.page.model.isMobile) {
          height += 28;
        }

        $iframeContainer.css('height', height);

        setTimeout(() => {
          if ($('.mobile').length) {
            return;
          }

          if ($('.email_apply_modal.in').length === 1) {
            $('.email_apply_modal #email_address').focus();
          } else {
            $('[data-email-input]').focus();
          }
        }, 200);
        break;
      case 'closed':
        closeYoloFrame(event.data.message, event.data.showError);
        break;
      default:
        // Do nothing.
    }
  });
}

async function loadGoogleButton() {
  const googleSignInButton = document.getElementById('google_button_container');
  const googleSignInClientId = zr.page.model.GOOGLE_SIGNIN_CLIENT_ID;

  $('.google_button_container').show();

  await import(/* webpackChunkName: "google-button" */ '@zr/common/js/google-sign-in')
    .then(({ loadAndRenderGoogleButton }) => {
      // the button just got rendered
      $('#loading_spinner').addClass('hide');

      loadAndRenderGoogleButton(googleSignInClientId,
        ((googleResponseObject) => {
          // the user attempted to sign in with google
          $('.submit_btn').attr('disabled', 'disabled');

          const loggingOptions = {
            regMethod: 'seo.fe.job-soft-reg-modal-Google.reg',
            loginMethod: 'seo.fe.job-soft-reg-modal-Google.sign-in',
          };

          $('#google_button_container').addClass('hide');
          $('#loading_spinner').removeClass('hide');

          const credentials = {
            token: googleResponseObject.credential,
            reg_method: loggingOptions.regMethod,
            login_method: loggingOptions.loginMethod,
          };

          registerWithZip(credentials, { googleSignInClientId }, (message, showError, error) => {
            $.log_event(message, error);
            $('.google_signin_container.google_button_container').hide();
          });
        }), googleSignInButton);
    });
}

function registerWithZip(params, configData, errorHandler) {
  // extra parameters to pass through to the zr login/register handler
  $.extend(params, zr.page.model.google_signin_login_or_register_params || {}, {
    search: configData?.search,
    location: configData?.location,
    encrypted_id: configData?.encrypted_id,
  });

  // Run the zr specific login/register script
  $.ajax(zr.page.model.google_signin_login_or_register_uri || '/auth/api/google_login_or_reg/v1', {
    method: 'POST',
    data: params,
  }).done((loginData) => {
    if (loginData.success) {
      // This is for the Phil job page
      if (zr.page.model.google_signin_refresh_and_apply) {
        zr.store({
          json: false,
          session: false,
        });
        window.location.reload(true);
        // If frontend tells us to just refresh
      } else if (zr.page.model.google_signin_refresh) {
        window.location.reload(true);
        // If frontend provided us a forwarding url
      } else if (zr.page.model.google_signin_next_url) {
        window.location = zr.page.model.google_signin_next_url;
        // Otherwise follow the next_url
      } else if (loginData.data && loginData.data.use_next_url && loginData.data.next_url) {
        window.location.href = loginData.data.next_url;
      } else if (zr.page.model.applyNowHref) {
        window.location.href = zr.page.model.applyNowHref; // + '&auto-apply=1';
        // Default to /
      } else {
        // TODO: Can this happen?
        window.location.href = '/';
      }
    } else {
      errorHandler('Failed authenticating with Ziprecruiter', true, loginData);
    }
  }).fail((loginFailData) => {
    try {
      if (loginFailData.responseJSON && loginFailData.responseJSON.data.error_code === 'user_already_logged_in') {
        // Most likely the user opened two tabs and is attempting to log in again, so let's just refresh the page
        document.location.reload(true);
        return;
      }
      if (loginFailData.responseText) {
        errorHandler('Failed authenticating with Ziprecruiter', true, loginFailData.responseText);
      }
    } catch (e) {
      errorHandler('Failed authenticating with Ziprecruiter', true, e.message);
    }
  });
}
